import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { delugeIdAtom } from '@root/entities/auth'
import { Error } from '@root/shared'

import { checkIsUserHasPremiumRequestAction } from './premium-requests'

import type { PremiumId } from '@root/entities/premium/model'

export const checkIsPremiumBelongToUsedAction = action(
  async (ctx, { premiumId }: { premiumId: PremiumId }) => {
    const delugeId = ctx.get(delugeIdAtom)
    if (!delugeId) {
      return Result.fail(Error.UnknownError.fromUnknown('No user id'))
    }

    const result = await ctx.schedule(() =>
      checkIsUserHasPremiumRequestAction(ctx, { premiumId }),
    )

    return result
  },
  'checkIsPremiumBelongToUsedAction',
)
